// @noflow
import './styles.css';

import { momentObj } from 'react-moment-proptypes';
import PropTypes from 'prop-types';
import * as React from 'react';

const TimelineTicksPropTypes = {
    tickMoment: momentObj.isRequired,
    tickStyle: PropTypes.object.isRequired
};

const TimelineTick = ({ tickMoment, tickStyle }) => (
    <div className="logs-timeline-component__tick" style={tickStyle}>
        {tickMoment.hours() === 0 && <span className="logs-timeline-component__tick-pipe">|</span>}
        <span className="logs-timeline-component__tick-time">{tickMoment.format('LT')}</span>
        <span className="logs-timeline-component__tick-point">•</span>
    </div>
);

TimelineTick.propTypes = TimelineTicksPropTypes;

export default TimelineTick;



// WEBPACK FOOTER //
// ./src/components/widgets/logs-timeline/timeline/tick/index.js